import { CvSuccessScreen } from 'components/cv-success';
import { getTrans } from 'modules/i18n';
import { getCvReviewTimeline } from './cvReviewTimeline';

/**
 * Terminal confirmation for the AUTHENTICATED CV flow. Once `submit()` succeeds the
 * wizard swaps to this screen (driven by the data port's `submitted` flag) so the
 * form cannot be re-submitted or edited. Shares the success screen + animation with
 * the guest `submitted` state.
 */
export const CvSubmittedScreen = () => (
  <CvSuccessScreen
    title={getTrans('cvBuilderPage.submitted.title')}
    description1={getTrans('cvBuilderPage.submitted.body1')}
    description2={getTrans('cvBuilderPage.submitted.body2')}
    timeline={getCvReviewTimeline()}
  />
);
